import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../index.css';
import LandingPageHeader from "./components/LandingPageHeader";
import LandingPageFooter from './components/LandingPageFooter';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore } from "./../firebase";
import { Download } from 'lucide-react';


function LandingPage() {
  const [movies, setMovies] = useState([]);
  const [currentPosterIndex, setCurrentPosterIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMovies = async () => {
      try {
        const q = query(collection(firestore, "movies"), where("prebook", "==", true));
        const querySnapshot = await getDocs(q);
        const moviesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setMovies(moviesData);
      } catch (error) {
        console.error("Error fetching movies:", error);
      }
    };

    fetchMovies();
  }, []);

  useEffect(() => {
    if (movies.length > 0) {
      const posterInterval = setInterval(() => {
        setCurrentPosterIndex(prev => (prev + 1) % movies.length);
        setCurrentImageIndex(0);
      }, 10000);

      const imageInterval = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % 2);
      }, 5000);

      return () => {
        clearInterval(posterInterval);
        clearInterval(imageInterval);
      };
    }
  }, [movies]);

  const handlePrebookClick = (movieId) => {
    navigate('/pre-book', { state: { movieId } });
  };

  const handleDownloadClick = async () => {
    setIsDownloading(true);
    try {
      // Replace this URL with your actual APK file URL
      const apkUrl = '/path/to/your/app.apk';
      const link = document.createElement('a');
      link.href = apkUrl;
      link.download = 'Ticketflix.apk';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  const renderMovieSection = () => {
    if (movies.length === 0) {
      return (
        <div className="text-center py-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">No Pre-booking Available</h2>
          <p className="text-xl text-gray-600">Check back later for exciting new movie pre-bookings!</p>
        </div>
      );
    }

    const currentMovie = movies[currentPosterIndex];
    const currentImage = currentImageIndex === 0 || !currentMovie.additionalImageUrls || currentMovie.additionalImageUrls.length === 0
      ? currentMovie.posterUrl 
      : currentMovie.additionalImageUrls[0];

    return (
      <div className="flex flex-col lg:flex-row items-center justify-center">
        <div className="w-full lg:w-1/2 mb-8 lg:mb-0 lg:pr-8 flex flex-col items-center lg:items-start">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4 text-center lg:text-left">
            {currentMovie.title}
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 mb-6 sm:text-center text-left pr-4 lg:px-0">
            {currentMovie.description}
          </p>
          <div className="flex justify-center w-full lg:justify-start">
            <button
              onClick={() => handlePrebookClick(currentMovie.id)}
              className="bg-red-800 text-white font-bold py-2 px-6 rounded-full hover:bg-yellow-700 transition duration-300"
            >
              Pre-book
            </button>
          </div> 
        </div>
        <div className="w-full lg:w-1/2 h-[50vh] lg:h-[80vh] flex justify-center items-center">
          <img
            src={currentImage}
            alt={`${currentMovie.title} ${
              currentImageIndex === 0 ? "Poster" : "Additional Image"
            }`}
            className="h-full aspect-[10/15] object-fit shadow-lg shadow-[#00000033] rounded-[21px] transition-opacity duration-500"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="App min-h-screen flex flex-col">
      <LandingPageHeader handleDownloadClick={handleDownloadClick} isDownloading={isDownloading} />
      <main className="flex-grow bg-gradient-to-br from-yellow-50 to-yellow-200">
        <section className="py-16 lg:py-20 px-4">
          <div className="max-w-6xl mx-auto">
            {renderMovieSection()}
          </div>
        </section>

                {/* New Download Section */}
                <section className="py-16 px-4 bg-gradient-to-r from-red-800 to-yellow-700">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-xl transform hover:scale-105 transition-transform duration-300">
              <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-red-800 to-yellow-700 text-transparent bg-clip-text">
                Download Our App Now
              </h2>
              <p className="text-gray-600 mb-6">
                Get exclusive access to pre-bookings, special offers, and amazing prizes!
              </p>
              <button
                onClick={handleDownloadClick}
                disabled={isDownloading}
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-red-800 to-yellow-700 text-white font-bold rounded-full hover:from-red-700 hover:to-yellow-600 transform hover:scale-105 transition-all duration-300 shadow-lg"
              >
                <Download className="mr-2" />
                {isDownloading ? "Downloading..." : "Download APP"}
              </button>
              <p className="text-sm text-gray-500 mt-4">
                Available for Android devices
              </p>
            </div>
          </div>
        </section>
      </main>
      <LandingPageFooter />
    </div>
  );
}

export default LandingPage;